import Vue from 'vue'
//import moment from 'moment'

import store from '@/store';
import currencies from './currencyInfo'

import {format} from 'date-fns'

Vue.filter('uppercase', (value) => value.toUpperCase());

const number = (value, decimals=0) => {
	if (value == undefined || value == null || typeof value != "number")
		return undefined;
	let negative = false;
	if (value < 0) {
		negative = true;
		value = -value;
	}
	if (decimals === 0)
		value = value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
	else
		value = value.toFixed(decimals).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
	if (negative)
		return `-${value}`;
	return value;
}

Vue.use({
	install(Vue) {
		Vue.prototype.$number = number;
	}
});

Vue.filter('number', number);

const formatDate = (value, dateFormat=store.getters.company.settings.dateFormat) => {
	if (!value)
		return value;
	try {
		return format(new Date(value.replace(/-/g, '/')), dateFormat);
	} catch (err) {
		return 'Invalid format';
	}
}
Vue.use({
	install(Vue) {
		Vue.prototype.$formatDate = formatDate;
	}
});
Vue.filter('formatDate', formatDate);

const formatDateTime = (value, dateFormat=`${store.getters.company.settings.dateFormat} ${store.getters.company.settings.timeFormat}`) => {
	if (!value)
		return value;

	try {
		return format(new Date(value.replace(/-/g, '/')), dateFormat);
	} catch (err) {
		return 'Invalid format';
	}
}
Vue.use({
	install(Vue) {
		Vue.prototype.$formatDateTime = formatDateTime;
	}
});
Vue.filter('formatDateTime', formatDateTime);

const currency = (value, currency, displayCurrency=false) => {
	if (currency == undefined)
		currency = store.getters.company.settings.homeCurrency;
	const currencyInfo = currencies[currency];
	const decimals = currencyInfo.precision;
	const symbol = currencyInfo.symbol;

	if (value == undefined || value == null || typeof value != "number")
		return undefined;
	let negative = false;
	if (value < 0) {
		negative = true;
		value = -value;
	}
	if (decimals === 0)
		value = value.toFixed(0).replace(/(\d)(?=(\d{3})$)/g, '$1,');
	else
		value = value.toFixed(decimals).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
	if (negative)
		value = `-${value}`;
	return `${symbol}${value}${displayCurrency ? ` ${currency}` : ''}`;
}
Vue.use({
	install(Vue) {
		Vue.prototype.$currency = currency;
	}
});
Vue.filter('currency', currency);

Vue.filter('duration', (duration) => {
	const days = Math.trunc(duration / (24*60));
	const hours = Math.trunc((duration - days*(24*60)) / 60);
	const minutes = duration % 60;
	return `${days ? `${days} days ` : ' '}${hours ? `${hours} hrs ` : ' '}${minutes ? `${minutes} mins` : ''}`.trim();
});
